module.exports = __webpack_public_path__ + "img/pensive.b9d8c309.gif";